module.exports = __webpack_public_path__ + "static/media/power_performance_gauge.079bae04.svg";